import type { IconProps } from '../types';

const Logout = (props: IconProps) => (
  <svg
    fill="#7A7A98"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path d="m20.136 8.045 7.16 7.16a1.124 1.124 0 0 1 0 1.59l-7.16 7.16a1.125 1.125 0 1 1-1.591-1.591l5.239-5.239H10v-2.25h13.784l-5.239-5.239a1.125 1.125 0 0 1 1.591-1.591ZM4 28V4h2.25v24H4Z" />
    <path d="M4 28h2.25V4H4v24Z" />
    <path d="M4 5.125C4 4.504 4.504 4 5.125 4h5.25a1.125 1.125 0 0 1 0 2.25h-5.25A1.125 1.125 0 0 1 4 5.125Z" />
    <path d="M5.125 4a1.125 1.125 0 0 0 0 2.25h5.25a1.125 1.125 0 0 0 0-2.25h-5.25ZM4 26.875c0-.621.504-1.125 1.125-1.125h5.25a1.125 1.125 0 0 1 0 2.25h-5.25A1.125 1.125 0 0 1 4 26.875Z" />
    <path d="M5.125 25.75h5.25a1.125 1.125 0 0 1 0 2.25h-5.25a1.125 1.125 0 1 1 0-2.25Z" />
  </svg>
);

export default Logout;
